var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        row: "",
        "align-center": "",
        "justify-center": "",
        "fill-height": ""
      }
    },
    [
      _c(
        "v-form",
        { ref: "form", attrs: { "lazy-validation": "" } },
        [
          _c(
            "v-alert",
            {
              attrs: { type: "error", dismissible: "" },
              model: {
                value: _vm.alert,
                callback: function($$v) {
                  _vm.alert = $$v
                },
                expression: "alert"
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]
          ),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "append-icon": _vm.show1 ? "visibility_off" : "visibility",
              rules: _vm.tokenRules,
              placeholder: "Type in access token here",
              label: "Access Token",
              type: _vm.show1 ? "text" : "password",
              required: ""
            },
            on: {
              "click:append": function($event) {
                _vm.show1 = !_vm.show1
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.toRoute()
              }
            },
            model: {
              value: _vm.token,
              callback: function($$v) {
                _vm.token = $$v
              },
              expression: "token"
            }
          }),
          _vm._v(" "),
          _c("input", {
            staticStyle: { display: "none" },
            attrs: { type: "text" }
          }),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { target: "_blank" },
              on: {
                click: function($event) {
                  return _vm.toRoute()
                }
              }
            },
            [_vm._v("\n          submit\n        ")]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { disabled: "", target: "_blank" },
              on: {
                click: function($event) {
                  return _vm.toGuest()
                }
              }
            },
            [_vm._v("Guest Access")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d8f13c4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d8f13c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Access.vue
// module id = null
// module chunks = 